var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMiniphone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_141",
    "data-name": "Group 141",
    transform: "translate(-17 -4007)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    cx: 7,
    cy: 7,
    r: 7,
    transform: "translate(17 4007)",
    fill: "#000203"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-smartphone",
    "data-name": "Icon feather-smartphone",
    transform: "translate(13.99 4007.414)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M8.217,3H11.8a.717.717,0,0,1,.717.717V9.455a.717.717,0,0,1-.717.717H8.217A.717.717,0,0,1,7.5,9.455V3.717A.717.717,0,0,1,8.217,3Z",
    fill: "none",
    stroke: "#feeef1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M18,27h0",
    transform: "translate(-7.99 -18.262)",
    fill: "none",
    stroke: "#feeef1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiniphone);
export default __webpack_public_path__ + "static/media/miniphone.390870bda38a68f927b4e52948e29714.svg";
export { ForwardRef as ReactComponent };